module.exports = __webpack_public_path__ + "img/model_29_zh.46965bbd.jpg";